import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { Table } from "../../../../../../Shared/Table/Table";

interface IAlertProps extends React.Props<Alert> {
    isReview?: boolean;
    data: any;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface IAlertState {}

export class Alert extends FormComponent<IAlertProps, IAlertState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { data, isReview } = this.props;
        return (
            <>
                <p>Alert Setup</p>
                <p>Third Party Firm settings</p>
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Define preferences at firm level",
                            onChange: (v) => {},
                            value: true,
                            disabled: this.props.isReview,
                        },
                    ]}
                />
                <p className="mt-10">Alerts that will be shown on the Third Party homepage</p>
                <Table
                    col={[
                        {
                            title:
                                "Please note that certain, high priority alerts cannot be disabled as they indicate that immediate action is required.",
                        },
                        { title: "Action Required" },
                        { title: "Important Information" },
                        { title: "Infomation" },
                    ]}
                    data={[]}
                />
                <br />
                <hr />
                {SectionHeader("Email Notifications")}
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <SelectEditor
                            disabled={this.props.isReview}
                            options={["Daily", "Weekly", "Never"]}
                            getText={(v) => {
                                return v;
                            }}
                            onChange={(v) => {}}
                            label="Tell Third Party that they have unread alerts"
                        />
                    </div>
                </div>
            </>
        );
    }
}
